import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const NAV = [
    { label: "Inicio", to: "/" },
    { label: "Aviso Médico", to: "/aviso-medico" },
    { label: "Privacidad", to: "/politica-privacidad" },
    { label: "Términos", to: "/terminos-de-uso" },
    { label: "Contacto", to: "/contacto" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 18);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#fbf8f5]/85 backdrop-blur-md border-b border-[#e8dcc8]/60"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-6xl mx-auto px-5 sm:px-8 py-3.5 flex items-center justify-between">
                <Link to="/" data-testid="nav-home-logo">
                    <Logo size={40} />
                </Link>

                <nav className="hidden md:flex items-center gap-9">
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            data-testid={`nav-link-${item.to.replace("/", "") || "home"}`}
                            className={({ isActive }) =>
                                `text-[0.92rem] tracking-wide transition-colors duration-300 ${
                                    isActive
                                        ? "text-[#b7677a]"
                                        : "text-[#5c5450] hover:text-[#b7677a]"
                                }`
                            }
                            end
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <button
                    className="md:hidden p-2 text-[#2d2a28]"
                    onClick={() => setOpen((o) => !o)}
                    aria-label="Menú"
                    data-testid="nav-menu-toggle"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="md:hidden bg-[#fbf8f5]/97 backdrop-blur-md border-t border-[#e8dcc8]/60"
                >
                    <div className="px-6 py-5 flex flex-col gap-4">
                        {NAV.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                data-testid={`nav-mobile-link-${item.to.replace("/", "") || "home"}`}
                                className={({ isActive }) =>
                                    `text-base py-1 ${
                                        isActive
                                            ? "text-[#b7677a]"
                                            : "text-[#2d2a28]"
                                    }`
                                }
                                end
                            >
                                {item.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
